// When adding new types, make sure all are handled by ChainingModalStepper
export const ModalTypes = Object.freeze({
  SHARE: 1,
  SIGNUP: 2,
  DONATE: 3,
  GROUP_INVITE: 4,
  LINKED_GROUP: 5,
})
